<!-- src/layouts/AuthLayout.vue -->
<template>
    <!-- Slim header for auth pages (no betslip, no sidebar) -->
    <AppHeader :slim="true" />

    <!-- Auth pages render directly without main content wrapper to avoid layout conflicts -->
    <RouterView />

    <!-- No BetSlip in auth layout by design -->
</template>

<script setup>
import { RouterView } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
</script>
